import dayjs from 'dayjs';
import {z} from 'zod';

import i18n from '@/i18n';
import {
  type CreateEventInput,
  type Event,
  EventSubType,
  EventType,
  type UpdateEventInput,
} from '@/services/graphqlHooks';

export const eventFormSchema = z.object({
  content: z.string().trim().min(1, i18n.t('Content is required')),
  date: z.string().trim().min(1, i18n.t('Date is required')),
  eventSubType: z.enum(EventSubType),
  type: z.enum(EventType),
  pairingIds: z
    .array(z.string().min(1, i18n.t('Resident is required')))
    .min(1, i18n.t('Resident is required')),
});

export type EventFormValues = z.infer<typeof eventFormSchema>;

export const eventFormDefaultValues = (
  isEmployee: boolean,
  event?: Event
): EventFormValues => ({
  content: event?.content || '',
  date: event?.date || '',
  eventSubType: event?.eventSubType || EventSubType.None,
  type: event?.type || (isEmployee ? EventType.Unverified : EventType.Casual),
  pairingIds: event?.pairingId ? [event.pairingId] : [],
});

export const mapEventFormValuesToCreateInput = (
  values: EventFormValues,
  pairingId: string
): CreateEventInput => ({
  content: values.content,
  date: dayjs(values.date).toISOString(),
  eventSubType: values.eventSubType,
  type: values.type,
  pairingId,
});

export const mapEventFormValuesToUpdateInput = (
  values: EventFormValues,
  event: Pick<Event, 'createdBy' | 'id' | 'isSharedToAuthorizedRelative'>,
  isSharedToAuthorizedRelative: boolean
): UpdateEventInput => ({
  content: values.content,
  createdBy: event.createdBy,
  date: values.date,
  eventSubType: values.eventSubType,
  id: event.id,
  isSharedToAuthorizedRelative,
  pairingId: values.pairingIds[0],
  type: values.type,
});
